// src/hooks/useDndSensors.ts
/**
 * Shared @dnd-kit sensors hook
 * Extracted from ImageThumbnailGrid for reuse across drag-drop components
 */

import {
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';

/**
 * Creates standardized dnd-kit sensors for drag-and-drop functionality
 * @param activationDistance - Minimum distance before drag starts (default: 8px)
 * @returns Configured sensors for DndContext
 */
export function useDndSensors(activationDistance = 8) {
  return useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: activationDistance,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );
}
